import {ChangeDetectionStrategy, Component, Input, OnInit, ViewChild} from "@angular/core";
import {ProductPricing} from "../../../../store/state/order.state";
import {NbTooltipDirective, NbTrigger} from "@nebular/theme";
import {EndpointsProvider} from "../../../../umbrella-common/endpoints/endpoint-provider.service";
import {NbPosition} from "@nebular/theme";
import {AuthenticationService} from "../../../../authentication/authentication.service";

@Component({
    selector: 'pricing-summary',
    templateUrl: './pricing-summary.template.html',
    styleUrls: ['./pricing-summary.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PricingSummaryComponent {

	readonly noop: NbTrigger = NbTrigger.NOOP;
	readonly nbStart: NbPosition = NbPosition.START;

	@Input() pricings: ProductPricing[];
	@Input() orderCorrelationId: string;
	@Input() allowPdfDownload: boolean;
	@Input() disablePdfDownloadButton: boolean = false;
	@Input() showDownloadButtonText: boolean = true;
	@Input() tooltipForDisableDownloadButton: string = null;
	@Input() clientView!: boolean;
	@Input() show3YearsTotalForClient: boolean;

	@ViewChild(NbTooltipDirective, {static: false}) tooltip: NbTooltipDirective;

	constructor(private endpoints: EndpointsProvider, private authService: AuthenticationService) {
	}

	totalPrice(): number {
		return this.pricings.map(p => p.totalPrice).reduce((p1, p2) => p1 + p2, 0);
	}

	downloadOfferPdf() {
		this.endpoints.documents.downloadOrderPdf(this.orderCorrelationId);
	}

	showTooltipIfAllowed() {
		this.tooltipForDisableDownloadButton != null && this.tooltip.show();
	}

	hideTooltip() {
		this.tooltipForDisableDownloadButton != null && this.tooltip.hide();
	}

}
